module.exports = __webpack_public_path__ + "static/img/1-1Z53009330V19.724f8f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z53009330V19.jpg
// module id = lEgP
// module chunks = 0